import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Playlist } from 'src/app/models/playlist';

import { VideoService } from 'src/app/services/video.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  @Input() playlist:Playlist;
  @Input() image:string;
  @Output() reloadPlaylist = new EventEmitter();

  form:FormGroup;

  constructor(
    public videoService:VideoService,
  ) { }

  ngOnInit() {
    this.form = new FormGroup({});

    let formPassword = new FormControl("", [
      Validators.required,
      Validators.maxLength(100),
    ]);
    this.form.addControl("formPassword", formPassword);
  }

  get formPassword(): FormControl {
    return this.form.get('formPassword') as FormControl;
  }

  async done(){

    if(this.form.invalid){
      return;
    }

    try{
      const response = await this.videoService.password(this.playlist.videoHashPublic, this.formPassword.value);
      if(response.password === true){
        // パスワードエラー
        this.formPassword.setErrors({serverError:"hoge"});
        return;
      }

      window.orpv = JSON.stringify(response);

      // API成功すればPlaylistオブジェクトを再構築
      this.reloadPlaylist.emit();
    }
    catch(e){
      console.log(e);
      return;
    }


    







  }



}
